// extracted by mini-css-extract-plugin
export default {"supportTile":"BS7lzzY5ekP5qkVjLDsH","questionIcon":"WOZnmUXIE9lLDcbuDPjE"};